import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Inbox } from 'src/app/models';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericService } from 'src/app/generic.service';

@Component({
  selector: 'app-msg-dialog',
  templateUrl: './msg-dialog.component.html',
  styles: [
  ]
})
export class MsgDialogComponent implements OnInit {
  title = 'Compose New Message';
  iloading = false;
  iForm: FormGroup;
  inbox: Inbox = new Inbox();

  constructor(public dialogRef: MatDialogRef<MsgDialogComponent>, @Inject(MAT_DIALOG_DATA) public ddata: any, private formBuilder: FormBuilder, public service: GenericService) { }

  get f(): any { return this.iForm.controls; }

  ngOnInit(): any {
    this.iForm = this.formBuilder.group({
      note: ['', [Validators.required]],
      subject: ['', [Validators.required]]
    });
  }

  close(): void {
    this.dialogRef.close(false);
  }

  onSubmit(): any {
    this.iloading = true;
    this.inbox.subject = this.iForm.get('subject').value;
    this.inbox.note = this.iForm.get('note').value;
    this.service.postDataByModel('inbox/SendMessageByClient', this.inbox).then(response => {
      if (response.success) {
        this.service.success('Messgae has been sent Successfully');
        this.iloading = false;
        this.dialogRef.close(true);
      } else {
        this.service.error(response.error);
        this.iloading = false;
      }
    });
  }

}
